import { LayoutHeader, Tabs, TabsItem, YStack } from '@shinetools/lumen-react'
import { FC, PropsWithChildren } from 'react'
import { useNavigate } from 'react-router'

import { ContextualSettingInput } from './elements/ContextualSettingInput'
import { CopySettingsButton } from './elements/CopySettingsButton'
import { MainSettingCta } from './elements/MainSettingCta'
import * as Styled from './styles'

interface ContextualTabbedSettingsProps {
  title: string
  tabs: TabsItem[]
  onTabSelected?: (value: string) => void
}

type ContextualTabbedSettingsType = FC<PropsWithChildren<ContextualTabbedSettingsProps>> & {
  CopySettingsButton: typeof CopySettingsButton
  MainSettingCta: typeof MainSettingCta
  ContextualSettingInput: typeof ContextualSettingInput
}

export const ContextualTabbedSettings: ContextualTabbedSettingsType = ({ title, tabs, onTabSelected, children }) => {
  const navigate = useNavigate()

  return (
    <Styled.MarginWrapperDiv>
      <YStack>
        <LayoutHeader title={title} onBack={() => navigate(-1)} />
        <Tabs items={tabs} onValueChange={onTabSelected} />
        {children}
      </YStack>
    </Styled.MarginWrapperDiv>
  )
}

ContextualTabbedSettings.CopySettingsButton = CopySettingsButton
ContextualTabbedSettings.MainSettingCta = MainSettingCta
ContextualTabbedSettings.ContextualSettingInput = ContextualSettingInput
